import { fromJS } from 'immutable/dist/immutable';
import { basicSort } from '../../../util/sortUtils';
import { refColumns, refSort } from '../../InfoReduxConstant';

export const CLEAR_EARTHQUAKE_INFO = 'CLEAR_EARTHQUAKE_INFO';

export const GET_EARTHQUAKE_INFO_REFERENCES_REQUEST = 'GET_EARTHQUAKE_INFO_REFERENCES_REQUEST';
export const GET_EARTHQUAKE_INFO_REFERENCES_SUCCESS = 'GET_EARTHQUAKE_INFO_REFERENCES_SUCCESS';
export const GET_EARTHQUAKE_INFO_REFERENCES_FAILURE = 'GET_EARTHQUAKE_INFO_REFERENCES_FAILURE';

export const GET_EARTHQUAKE_INFO_REQUEST = 'GET_EARTHQUAKE_INFO_REQUEST';
export const GET_EARTHQUAKE_INFO_SUCCESS = 'GET_EARTHQUAKE_INFO_SUCCESS';
export const GET_EARTHQUAKE_INFO_FAILURE = 'GET_EARTHQUAKE_INFO_FAILURE';

export const EARTHQUAKE_INFO_REFERENCE_SORT = 'EARTHQUAKE_INFO_REFERENCE_SORT';
export const EARTHQUAKE_INFO_TOGGLE_COLUMN = 'EARTHQUAKE_INFO_TOGGLE_COLUMN';
const initialState = fromJS({
  fetchedEarthquake: false,
  earthquake: {},
  fetchedReferences: false,
  references: [],

  sort: refSort,
  visibleColumns: refColumns,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const earthquakeInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EARTHQUAKE_INFO:
      return initialState;

    case EARTHQUAKE_INFO_REFERENCE_SORT:
      return state.merge(fromJS({
        references: basicSort(action.sort, state.get('references')),
        sort: action.sort,
      }));

    case GET_EARTHQUAKE_INFO_REFERENCES_REQUEST:
      return state.set('fetchedReferences', false);
    case GET_EARTHQUAKE_INFO_REFERENCES_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case GET_EARTHQUAKE_INFO_REFERENCES_FAILURE:
      return state.set('fetchedReferences', true);

    case GET_EARTHQUAKE_INFO_REQUEST:
      return state.set('fetchedEarthquake', false);
    case GET_EARTHQUAKE_INFO_SUCCESS:
      return state.merge(fromJS({
        fetchedEarthquake: true,
        earthquake: action.response,
      }));
    case GET_EARTHQUAKE_INFO_FAILURE:
      return state.set('fetchedEarthquake', true);

    case EARTHQUAKE_INFO_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
